import * as React from "react";
import {Icon} from "./Icon";

export class BrandingIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M27.48,20.8a2.52,2.52,0,0,1,1.61.65l.2.18c1.71,2.14-1.06,4.31-1.06,4.31C25.37,28.07,22,26,22,26c1.14.22,2.63-2.8,2.63-2.8C25.61,21.31,26.65,20.8,27.48,20.8Zm3.09-4.27,2.89,2.61a33.08,33.08,0,0,1-2.58,2.14l-2.12-1.81S29.42,18.27,30.56,16.53ZM43.64,4h.07c.32,0,.47.33,0,1.38a50.33,50.33,0,0,1-9.46,13l-.05-.05-3-2.67,0,0c2.53-3.71,6.79-9.1,11.45-11.23A2.93,2.93,0,0,1,43.64,4Z" />
        <path d="M44,36V9c-.53.91-1.2,2-2,3.17V34H6V10H32.91c.57-.68,1.16-1.35,1.78-2H4V36H22v6H14v2H34V42H26V36Z" />
      </svg>
    </Icon>;
  }
}
